module.exports = __webpack_public_path__ + "img/2_285.5053fdbf.png";